import {TypographyStylesProvider} from "@mantine/core";

export const IndexPage = () => {
    return <TypographyStylesProvider>
        <p>EGW Publication Management</p>
        <p>Nothing to see here</p>
    </TypographyStylesProvider>
}